import React from "react";
import Input from "../../../../../components/input/Input";
import { loadCouponEffect } from "../../../../../helpers/loadOption/LoadOption";
import { handleChangeCoupon } from "../../helpers/FormHandle";
import AsyncSelect from "react-select/async";

interface LuxuryProps {
  luxury: any;
  setCheckLuxury: (check: boolean) => void;
  setLuxury: (luxury: any) => void;
}

const LuxuryCard: React.FC<LuxuryProps> = ({
  setCheckLuxury,
  setLuxury,
  luxury,
}) => {
  return (
    <div className="my-5">
      <div className="flex justify-between items-end">
        <h1 className="text-2xl">Luxury</h1>
        <h1
          onClick={() => setCheckLuxury(false)}
          className="hover:text-softPink cursor-pointer"
        >
          Delete
        </h1>
      </div>
      <hr className="my-3" />
      <div className="pt-2">
        <div className="flex justify-between">
          <div className="w-1/2">
            <h1 className="md:text-base text-sm text-inputColor">Quantity</h1>
            <Input
              name="name"
              type="number"
              value={luxury.quantity}
              handleChange={(e: any) =>
                setLuxury({
                  ...luxury,
                  quantity: +e.target.value,
                })
              }
              placeholder="Place Holder"
            />
          </div>
          <div className="w-1/2 ml-7">
            <h1 className="md:text-base text-sm text-inputColor">
              Validity Period (Day)
            </h1>
            <Input
              name="name"
              type="number"
              value={luxury.validity_period}
              handleChange={(e: any) =>
                setLuxury({
                  ...luxury,
                  validity_period: +e.target.value,
                })
              }
              placeholder="Place Holder"
            />
          </div>
        </div>
        <div className="w-full">
          <div>
            <h1 className="md:text-base text-sm text-inputColor">
              Package for
            </h1>
            <AsyncSelect
              cacheOptions
              defaultOptions
              value={{
                value: luxury.package_coupon_effect_id,
                label: luxury.package_coupon_name,
              }}
              loadOptions={(inputValue: any) =>
                loadCouponEffect(inputValue, "luxury")
              }
              onChange={(coupon) =>
                handleChangeCoupon(coupon, "luxury", setLuxury, luxury)
              }
              className="my-3.5 font-rom text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LuxuryCard;
